import React, {useState, useEffect} from 'react'
import {changeLogo, setFormData} from '../../redux/modules/app'
import {connect, useDispatch} from 'react-redux'
import ButtonFalseInput from '../../Components/Buttons/ButtonFalseInput'
import ModalNoValidInsurance from '../../Components/Modals/ModalNoValidInsurance'
import {useHistory} from 'react-router-dom'
import {getBeneficiaries} from '../../Utils/api'
import LoadingSura from '../../Components/Loading/LoadingSura'
import Modal from 'react-modal'
import {setCopayUserData} from '../../redux/modules/user'
import {encrypt} from '../../Utils/utils'
import * as Sentry from '@sentry/react'
import {setContext} from '@sentry/react'
import {
  _formatRut,
  _validateMail,
  _validateRut,
  _getDv,
  _capitalize,
} from '../../Utils/tools'
import {logEvent} from '../../Utils/utils'

function Beneficiaries(props) {
  const dispatch = useDispatch()
  const [modalNoValidInsurance, setModalNoValidInsurance] = useState(false)
  const [benefit, setBenefit] = useState(null)
  const history = useHistory()
  const [notBeneficiary, setNotBeneficiary] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(async () => {
    try {
      setLoading(true)
      let userData = sessionStorage.getItem('USER_DATA')
      userData = JSON.parse(userData)
      let response = await getBeneficiaries(userData.identity)
      try {
        if (response?.data?.code !== 0) {
          setContext('Error Sura', {
            ...response?.data,
            listaBeneficiarios: JSON.stringify(
              response?.data?.listaBeneficiarios,
            ),
          })
          Sentry.captureMessage('Error Get Beneficiaries')
        }
      } catch (ignore) {}

      if (
        response?.message === 'OK: Success' &&
        response?.data?.numRegistros > 0
      ) {
        logEvent('Session Started', {'Validated Insurance Policy': 'TRUE'})
        setBenefit(response.data.listaBeneficiarios)
      } else {
        logEvent('Session Started', {'Validated Insurance Policy': 'FALSE'})
        setNotBeneficiary(true)
      }
    } catch (ignore) {
    } finally {
      setLoading(false)
    }
  }, [])

  function nextAction(userData) {
    if (userData) {
      let encryptedData = encrypt(userData)

      let identity = userData?.rut + '-' + _getDv(userData?.rut)
      let titular_identity =
        userData?.holder_identity + '-' + _getDv(userData?.holder_identity)

      props.setFormData({
        ...props.formData,
        full_name: {
          ...props.formData.full_name,
          value: _capitalize(userData?.nombre || ''),
        },
        rut: {
          ...props.formData.rut,
          value: ![undefined, null, '', ' '].includes(userData?.rut)
            ? _validateRut(identity)
              ? _formatRut(identity)
              : null
            : null,
        },
        titular_identity: {
          ...props.formData.titular_identity,
          value: ![undefined, null, '', ' '].includes(userData?.holder_identity)
            ? _validateRut(titular_identity)
              ? _formatRut(titular_identity)
              : null
            : null,
        },
        email: {
          ...props.formData.email,
          value: ![undefined, null, '', ' '].includes(userData?.email)
            ? _validateMail(userData?.email)
              ? userData?.email?.toLowerCase()
              : null
            : null,
        },
      })
      dispatch(setCopayUserData(encryptedData))
    }
    history.push('/search')
  }

  return (
    <>
      {loading && <LoadingSura />}
      {!notBeneficiary && benefit && (
        <>
          {process.env.REACT_APP_CLIENT_NAME !== 'UC Christus' && (
            <div className="content-responsive mx-auto d-flex justify-content-between py-3 px-3 px-md-0">
              <div
                className="breadcrumbs c-pointer"
                onClick={() => {
                  history.push('/')
                }}>
                <a className="d-flex align-items-center">
                  <i className="icon-chevron-right icon-reverse"></i>
                </a>
                <span className="title-primary--regular line-14">Volver</span>
              </div>
            </div>
          )}
          <div className="flex-grow-1 pb-md-2">
            <div className="content-responsive mx-auto mb-5">
              <div className="mx-auto px-3">
                <p className="txt-3--bold-db mb-4">
                  Selecciona para quien necesitas comprar medicamentos
                </p>
                <p className="txt-5--bold-db mb-3">Titular</p>
                {benefit && (
                  <>
                    <ButtonFalseInput
                      text={
                        benefit.filter((c) => c.parentesco === 'TITULAR')[0]
                          .nombre
                      }
                      onClick={() =>
                        nextAction({
                          ...benefit.filter(
                            (c) => c.parentesco === 'TITULAR',
                          )[0],
                          holder_identity: benefit.filter(
                            (c) => c.parentesco === 'TITULAR',
                          )[0].rut,
                        })
                      }
                    />
                    <p className="txt-5--bold-db mb-3 mt-4">Beneficiarios</p>
                    {benefit
                      .filter((c) => c.parentesco !== 'TITULAR')
                      .map((c, i) => (
                        <ButtonFalseInput
                          key={i}
                          text={c.nombre}
                          onClick={() =>
                            nextAction({
                              ...c,
                              holder_identity: benefit.filter(
                                (c) => c.parentesco === 'TITULAR',
                              )[0].rut,
                            })
                          }
                        />
                      ))}
                  </>
                )}
              </div>
            </div>
            <ModalNoValidInsurance
              modalNoValidInsurance={modalNoValidInsurance}
              setModalNoValidInsurance={setModalNoValidInsurance}
            />
          </div>
        </>
      )}
      <Modal
        isOpen={notBeneficiary}
        onAfterOpen={null}
        onRequestClose={() => setNotBeneficiary(false)}
        className="modal-custom"
        overlayClassName="modal-custom-bg"
        contentLabel="Modal1"
        ariaHideApp={false}>
        <div className="d-flex flex-column align-items-center justify-content-center">
          <h2 className="title-primary--3xl-regular mb-3 text-center">
            Usted no cuenta con polizas disponibles. ¿Desea continuar sin
            Polizas?
          </h2>
          <div className="mx-auto">
            <button
              className="btn-default w-100 btn-next mt-3"
              onClick={() => {
                setNotBeneficiary(false)
                nextAction()
              }}>
              Continuar
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    formData: state.app?.formData,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeLogo: (logo) => dispatch(changeLogo(logo)),
    setFormData: (formData) => dispatch(setFormData(formData)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Beneficiaries)
